module.exports = __webpack_public_path__ + "img/informationSet.911964c6.svg";